import { API_URL } from "@/config/constants";
import axios from "axios";
import { IAcceptInvitationResponse, IInvitation } from "./invitations.types";

const API = `${API_URL}/invitations`;

export const getInvitationByCode = async (code: string) => {
    const result = await axios.get<IInvitation>(`${API}/by-code/${code}`);
    return result.data;
};

export const getInvitationById = async (id: number) => {
    const result = await axios.get<IInvitation>(`${API}/by-id/${id}`);
    return result.data;
};

export const acceptInvitation = async (
    id: number,
    data: { new_password: string; first_name: string; last_name: string }
) => {
    const result = await axios.put<IAcceptInvitationResponse>(
        `${API}/${id}`,
        data
    );
    return result.data;
};

export const resendInvitation = async (id: number) => {
    const result = await axios.post(`${API}/${id}/resend`);
    return result.data;
};
